<template>
  <div>
    <v-dialog v-model="showPopup" persistent width="450">
      <v-card class="session-timeout-popup">
        <v-card-title class="headline" primary-title>
          <h3 class="headline">Session Time Out</h3>
          <v-spacer></v-spacer>
          <v-btn class="close-btn" depressed @click="showPopup = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <div>
            <p>
              Sub-brand management tool has been inactive for 14 minutes.
              For security reasons, you will be logged out in
              <b>{{minutes}}:{{seconds}}</b> minute.
            </p>
            <p>
              Choose
              <b>Continue</b> to remain logged in or
              <b>Log Out</b> to end your session now.
            </p>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" outlined @click="endSession()" class="mr-2">Log Out</v-btn>
          <v-btn color="primary" depressed @click="renewSession()">Continue</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div style="display:none">{{resetSession}}</div>
    <div></div>
  </div>
</template>

<script>
import moment from 'moment'
import serviceRegistery from '../mixins/serviceRegistery'

export default {
  data() {
    return {
      totalMinutes: 15,
      showPopupBeforeMunites: 1,
      maxSessionTimeOutMinutes: 10,
      showPopup: false,
      start: '',
      diff: '',
      duration: '',
      minutes: '',
      seconds: '',
      count: '',
      countToShowPopup: '',
      displayCountdownIntervalId: ''
    }
  },
  computed: {
    resetSession() {
      this.initializeTimerInput()
      return this.$store.state.appStore.sessionManagement.resetSession
    }
  },
  props: {},
  created() {
    this.initializeTimerInput()
    this.displayCountdownIntervalId = setInterval(
      () => this.checkSessionStatus(),
      1 * 1000
    )
  },
  methods: {
    initializeTimerInput() {
      this.start = Date.now()
      this.countToShowPopup = this.showPopupBeforeMunites * 60
      this.duration = this.totalMinutes * 60
      this.count = this.totalMinutes * 60 || 900
    },
    checkSessionStatus() {
      if (this.count === 0) {
        window.clearInterval(this.displayCountdownIntervalId)
        this.endSession(true)
        return
      }

      this.diff = this.duration - (((Date.now() - this.start) / 1000) | 0)

      this.minutes = (this.diff / 60) | 0
      this.seconds = this.diff % 60 | 0

      this.minutes = this.minutes < 10 ? '0' + this.minutes : this.minutes
      this.seconds = this.seconds < 10 ? '0' + this.seconds : this.seconds

      if (this.diff <= 0) {
        // add one second so that the count down starts at the full duration
        // example 05:00 not 04:59
        this.start = Date.now() + 1000
      }

      if (this.countToShowPopup === this.count) {
        this.showPopup = true
      }

      this.count--
    },
    endSession(e) {
      window.clearInterval(this.displayCountdownIntervalId)
      serviceRegistery
        .makeCall({
          url: this.$hostname + 'services/authenticator/logout',
          method: 'POST'
        })
        .then(response => {
          window.location.assign(this.$hostname)
          this.$store.state.sessionManagementStore.beginSessionTimer = false
        })
        .catch(error => {
          window.location.assign(this.$hostname)
          this.$store.state.sessionManagementStore.beginSessionTimer = false
        })
    },
    renewSession() {
      this.initializeTimerInput()
      this.showPopup = false
    }
  }
}
</script>

<style lang="scss">
.session-timeout-popup {
  border-radius: 4px 4px 0px 0px;
  .v-card__title.headline {
    box-shadow: inset 0px -1px 0px #d6d6d6;
    background: #fafafa;
  }
  .headline {
    font-size: 18px !important;
    line-height: 22px;
    color: #383838;
    font-weight: 500;
  }
  .v-card__text {
    color: #383838 !important;
    font-size: 15px;
    padding-top: 24px !important;
  }
  .v-card__actions {
    padding: 0 24px 24px 24px;
  }
  .close-btn {
    background-color: transparent !important;
    color: #888888;
    padding: 0px !important;
    min-width: 16px !important;
    &:hover:before,
    &:focus:before,
    &:active:before,
    &:before {
      background-color: transparent !important;
    }
  }
}
</style>


